import styled from 'styled-components';

export const WrapperMemberList = styled.div`
  max-height: 500px;
  overflow: auto;
`;